import React from "react";
import { XCircle, CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

export const PlanChooser = ({ plans = [], onSelect, onClose, paying }) => (
  <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" onClick={onClose}>
    <div className="w-full max-w-md rounded-2xl bg-white p-6 sm:p-8 shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="plan-chooser-modal">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="font-display text-2xl font-extrabold text-slate-900">Unlock your full report</h3>
          <p className="mt-1 text-sm text-slate-500">Secure one-time payment via Stripe.</p>
        </div>
        <button onClick={onClose} className="text-slate-400 hover:text-slate-700" data-testid="plan-chooser-close"><XCircle className="h-6 w-6" /></button>
      </div>
      <div className="mt-6">
        {plans.map((p) => (
          <div key={p.id} className="rounded-2xl border-2 border-primary/40 p-6 flex flex-col">
            <p className="font-display font-bold text-slate-900">{p.label}</p>
            <p className="mt-4 font-display text-4xl font-extrabold text-slate-900">
              ${p.price?.toFixed(2)} <span className="text-sm font-semibold text-slate-400">{p.currency?.toUpperCase()} one-time</span>
            </p>
            <ul className="mt-4 space-y-2 text-sm text-slate-600">
              <li className="flex items-start gap-2"><CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" /> This report unlocked forever</li>
              <li className="flex items-start gap-2"><CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" /> Run new fully-unlocked reports for 30 days</li>
              <li className="flex items-start gap-2"><CheckCircle2 className="h-4 w-4 text-primary shrink-0 mt-0.5" /> Downloadable HTML report</li>
            </ul>
            <Button
              onClick={() => onSelect(p.id)}
              disabled={paying}
              className="mt-6 w-full rounded-lg bg-primary hover:bg-primary/90"
              data-testid="plan-select-button"
            >
              {paying ? (<><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Redirecting…</>) : "Unlock Full Access"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  </div>
);
